import Sidebar from "./Sidebar";
import "./Layout.css";

export default function ProtectedLayout({ children }) {
  return (
    <div className="layout-container">
      <Sidebar />

      <div className="layout-content">
        {children}
      </div>
    </div>
  );
}
